import { Button, Tooltip } from '@eleveo/components-react';
import { QuestionSquareIcon } from '@eleveo/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Header as LayoutHeader } from './LayoutNext';

import type { HeaderProps } from './LayoutNext';

const URL = 'https://help.eleveo.com/display/WFM/';

export const Header = ({ children, ...props }: HeaderProps) => {
  const { t } = useTranslation();

  return (
    <LayoutHeader {...props}>
      {children}
      <Tooltip content={t('layout.goToDocumentation')}>
        <Button
          aria-label={t('layout.goToDocumentation')}
          as="a"
          href={URL}
          target="_blank"
          variant="quiet"
          className="mis-auto"
          rel="noopener noreferrer"
          testId="link-to-wfm-doc"
        >
          <QuestionSquareIcon />
        </Button>
      </Tooltip>
    </LayoutHeader>
  );
};
